module.exports = __webpack_public_path__ + "h5/img/top.7ebc6d61.png";